import { ProductGender } from '@onrunning/backstage-models';
import { ProductGroupFabricsProducts } from './product-group-fabric-products.model';
import { ProductMainGroups } from './product-main-group.enum';

export class GenderMainGroupProducts {
  public name: string;
  public code: string;
  public pictureUrl: string;
  public mainGroup: ProductMainGroups;
  public gender: ProductGender;
  public selected: boolean;
  public total: number;
  public productGroupsFabricsProducts: ProductGroupFabricsProducts[];
}
